<template>
  <div>
    <InputTimePicker
      :value="timeFormated"
      :disable="disable"
      @click="showModalTimePicker"
    />
    <Popup
      v-if="isPopupOpen"
      @close="toggleTimePicker"
    >
      <ModalTimePicker
        :label-button="labelButton"
        :new-time="time"
        :value-default="defaultTime"
        @apply="applyTime"
        @change="changeTimeSelected"
      />
    </Popup>
  </div>
</template>
<script>
import InputTimePicker from '@/packages/ui/components/TimePicker/InputTimePicker.vue';
import ModalTimePicker from '@/packages/ui/components/TimePicker/ModalTimePicker.vue';
import Popup from '@/packages/ui/components/Popup/Popup.vue';
import { getDateByUnixSeconds } from '@/packages/ui/components/DatePicker/convert';

export default {
  components: { Popup, InputTimePicker, ModalTimePicker },
  props: {
    labelButton: {
      type: String,
      default: 'Aplicar',
    },
    value: {
      type: [Number, Object],
      default: () => {},
    },
    disable: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isPopupOpen: false,
      timeFormated: '',
      defaultTime: '',
      time: {
        hour: '',
        minute: '',
        period: '',
      },
    };
  },
  watch: {
    value(newValue) {
      if (typeof this.value === 'number') {
        this.value = newValue;
        return this.verifyDate();
      }
      if (newValue === null) {
        return this.timeFormated = '';
      }
      return '';
    },
  },
  created() {
    if (!this.value) return '';
    this.verifyDate();
  },
  methods: {
    showModalTimePicker() {
      this.isPopupOpen = true;
    },
    toggleTimePicker(value) {
      this.isPopupOpen = value;
    },
    applyTime(time) {
      this.timeFormated = `${time.hour}:${time.minute} ${time.period}`;
      this.convertTime(time);
      this.toggleTimePicker(false);
    },
    getPeriod(hour) {
      return hour >= 12 ? 'PM' : 'AM';
    },
    convertHour(hour, period) {
      const hourFormatted = period === 'PM' && hour !== 12 ? hour - 12 : hour;
      return hourFormatted < 10 ? `0${hourFormatted}` : hourFormatted;
    },
    convertMinutes(minutes) {
      return minutes < 10 ? `0${minutes}` : minutes;
    },
    convertTime(time) {
      const data = getDateByUnixSeconds(this.value);

      time.period === 'AM' && time.hour === '12' ? (time.hour = '00') : time.hour;

      const hour = time.period === 'PM' && time.hour !== '12'
        ? parseInt(time.hour) + 12
        : time.hour;

      data.setHours(hour);
      data.setMinutes(time.minute);
      this.$emit('time', data.getTime() / 1000);
    },
    verifyDate() {
      const date = getDateByUnixSeconds(this.value);
      const hour = date.getHours();
      const period = this.getPeriod(hour);
      this.defaultTime = `${this.convertHour(
        hour,
        period,
      )}:${this.convertMinutes(date.getMinutes())} ${period}`;
      this.timeFormated = this.defaultTime;
      if (hour === 0) {
        this.applyTime({
          hour: '12',
          minute: `${this.convertMinutes(date.getMinutes())}`,
          period: 'AM',
        });
      }
    },
    changeTimeSelected(value) {
      const [hour, minute, period] = this.timeFormated.split(/:|\s/);
      this.timeFormated = `${value.hour === '' ? hour : value.hour}:${value.minute === '' ? minute : value.minute} ${value.period === '' ? period : value.period}`;
      this.time = {
        ...value,
        hour: value.hour === '' ? hour : value.hour,
        minute: value.minute === '' ? minute : value.minute,
        period: value.period === '' ? period : value.period,
      };
    },
  },
};
</script>
